export default __webpack_public_path__ + "static/discord@2x-a991f1786cfb66abbca390d6bc22d81d.png";